// src/components/mindworkout/MindWorkoutLanding.js
import React from 'react';
import WorkoutHeroSection from './sections/WorkoutHeroSection';
import WorkoutFeatureSection from './sections/WorkoutFeatureSection';
import WorkoutDetailSection from './sections/WorkoutDetailSection';
import WorkoutReviewSection from './sections/WorkoutReviewSection';
import WorkoutCTASection from './sections/WorkoutCTASection';
import WorkoutFooter from './sections/WorkoutFooter';

const MindWorkoutLanding = () => {
    return (
        <div className="w-full min-h-screen overflow-x-hidden">
            <WorkoutHeroSection />
            <WorkoutFeatureSection />
            <WorkoutDetailSection />
            <WorkoutReviewSection />
            <WorkoutCTASection />
            <WorkoutFooter />
        </div>
    );
};

export default MindWorkoutLanding;
